import type { TariffPlan } from '../../TariffItem';
import type { TariffApplicationFormValues } from './types';

export const getApplicationInitialValues = (
    plan: TariffPlan | null,
    accountUuid: string,
): TariffApplicationFormValues => ({
    planId: plan?.id == null ? '' : String(plan.id),
    planKey: plan?.key || '',
    accountUuid: accountUuid || '',
    companyName: '',
    taxId: '',
    phone: '',
    email: '',
    legalAddress: '',
    representativeName: '',
});
